'use strict'
var twentyninetimes = twentyninetimes || {}

twentyninetimes.blockCheckout =
  twentyninetimes.blockCheckout ||
  (function () {
    function init() {
      var block_checkout = document.querySelectorAll('.js-block-checkout')

      if (block_checkout && block_checkout.length > 0) {
        for (let i = 0; i < block_checkout.length; i++) {
          const currentBlock = block_checkout[i]

          checkoutSections(currentBlock)
          checkoutTriggers(currentBlock)
        }
        // checkoutSections(block_checkout);
        // checkoutTriggers(block_checkout);
      }
    }

    function checkoutSections(block) {
      let content_sections = block.querySelectorAll('.js-sort-children')

      if (content_sections) {
        // Reorder content sections
        content_sections.forEach((section, index) => {
          var children = section.children

          Array.from(children).forEach((child, index) => {
            if (child.classList.contains('js-append-child')) {
              // get rid of the whitespace text nodes
              section.removeChild(child)
              section.appendChild(child)
            }
          })
        })
      }
    }

    function checkoutTriggers(block) {
      let triggers = block.querySelectorAll('.js-checkout-input')

      if (triggers) {
        triggers.forEach((trigger) => {
          trigger.addEventListener('input', function (e) {
            e.stopPropagation()

            var scrollTop = Math.max(
                window.scrollY,
                document.documentElement.scrollTop,
                document.body.scrollTop
              ),
              header_height = window.innerWidth > 991 ? 130 : 120

            triggers.forEach((input) => {
              var id = input.getAttribute('id'),
                content = block.querySelector(
                  '.js-checkout-content[data-content="' + id + '"]'
                )

              if (input.checked) {
                console.log('checked: active')
                input.classList.add('active')
                content.classList.add('active')

                var elmnt_scrollTop =
                  scrollTop +
                  content.getBoundingClientRect().top -
                  header_height

                setTimeout(() => {
                  scrollTo(elmnt_scrollTop, 500)
                }, 50)

                // Trigger window resize so flickity slider resizes
                window.dispatchEvent(new Event('resize'))
              } else {
                input.classList.remove('active')
                content.classList.remove('active')
              }
            })
          })
        })
      }
    }

    return {
      init: init,
    }
  })()
